export default {
  HANDLE_API_ERROR({commit}, error) {
    if (error.response == undefined) {
      commit('app/SHOW_NOTIFICATION', {body: `Erro interno: ${error.message}`}, {root: true})
      return Promise.reject(error)
    }
    let message =  error.response.data.message
    if ([401, 403].includes(error.response.status)) {
      commit('account/LOGOUT', null, {root: true})
      message = 'Sua sessão expirou. Faça login novamente.'
    }
    commit('app/SHOW_NOTIFICATION', {body: error.response.data.message}, {root: true})
    return Promise.reject(error)
  }
}
